import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import ThankYouModal from '../components/subscription/ThankYouModal';
import Home from './Home';
import { useSubscription } from '../hooks/useSubscription';

const SubscriptionThankYou = () => {
  const [showModal, setShowModal] = useState(false);
  const [reloadTrigger, setReloadTrigger] = useState(0);
  const subscription = useSubscription(reloadTrigger);
  const navigate = useNavigate();

  useEffect(() => {
    // Increase reload trigger to force subscription refresh
    setReloadTrigger(prev => prev + 1);
  }, []);

  useEffect(() => {
    // Show modal only if we have a paid subscription
    if (subscription && subscription.hasSubscription()) {
      setShowModal(true);
    }
  }, [subscription]);

  useEffect(() => {
    // If subscription data is loaded and user doesn't have a paid subscription, redirect to home
    if (subscription && !subscription.hasSubscription()) {
      navigate('/', { replace: true });
    }
  }, [subscription, navigate]);

  const handleModalClose = () => {
    setShowModal(false);
  };

  // Don't render anything if redirecting
  if (subscription && !subscription.hasSubscription()) {
    return null;
  }

  return (
    <>
      {/* Load the Home page content underneath */}
      <Home />
      
      {/* Show the thank you modal on top */}
      <ThankYouModal 
        visible={showModal} 
        onClose={handleModalClose}
        subscription={subscription}
      />
    </>
  );
};

export default SubscriptionThankYou; 